import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { notificationsApi } from '../../api/notifications';

const notificationIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Consumes a push deep link after the authenticated app has finished loading. */
export default function PushNotificationClickHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const notificationId = params.get('notificationId');
    if (!notificationIdPattern.test(notificationId || '')) return;

    // Remove the one-time marker before the request settles so refresh/back does
    // not issue a second read request. The post route itself remains unchanged.
    params.delete('notificationId');
    const nextSearch = params.toString();
    navigate({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : '', hash: location.hash }, { replace: true });
    notificationsApi.read(notificationId).catch(() => {
      // Opening content must not fail merely because a receipt update failed.
    });
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
